export default "__VITE_ASSET__4b6ad6d0__"